<template>
  <div :class="mainClasses">

    <div class="header-menu__centered">
      <nav class="header-menu__nav">
        <ul class="header-menu__items">
          <li class="header-menu__item" v-for="(item, index) in items" :key="`item-${index}`">
            <router-link :to="item.route" @click.native="handleClick" v-if="item.route">
              <span>{{ item.text }}</span>
            </router-link>
            <a :href="`mailto:${item.mailto}`" v-else>
              <span>{{ item.text }}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <TheHeaderLanguages class="header-menu__languages" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TheHeaderLanguages from './TheHeaderLanguages'

export default {
  name: 'TheHeaderMenu',
  components: {
    TheHeaderLanguages
  },
  computed: {
    ...mapGetters({
      toggle: 'header/getToggle',
      items: 'header/getItems'
    }),
    mainClasses () {
      return [
        'header-menu',
        { 'is-active': this.toggle }
      ]
    }
  },
  methods: {
    ...mapActions({
      updateToggle: 'header/updateToggle'
    }),
    handleClick () {
      this.updateToggle(false)
    }
  }
}
</script>

<style lang="scss">
.header-menu {
  width: 100vw;
  height: 100vh;
  background-color: rgba(black, 0.96);
  transition: all 400ms $ease-in-out-sine;
  opacity: 0;
  visibility: hidden;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &.is-active{
    visibility: visible;
    opacity: 1;

    .header-menu__nav{
      opacity: 1;
      visibility: visible;
      transform: scale(1);
      transition-delay: 300ms;
    }
  }

  // Centered

  &__centered{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex: 1 1 auto;
  }

  // Nav

  &__nav{
    opacity: 0;
    visibility: hidden;
    transform: scale(1.3);
    flex: 0 1 auto;
    transition: all 400ms $ease-in-out-sine;
  }

  // Items

  &__items {
    @include no-type-list;
    @include media("small-medium") {
      flex-direction: column;
    }
    @include media("large") {
      flex-direction: row;
      &:hover {
        > *:not(:hover) {
          //blurred
          filter: blur(0.5rem);
          opacity: 0.5;
        }
      }
    }

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    flex: 1 1 auto;
  }

  // Item

  &__item{
    $navigation-item-opacity: 0.6;
    @include media("small-medium"){
      margin: 0 1rem 2rem 1rem;
    }
    @include media("large"){
      margin: 0 1rem;
    }

    flex: 0 1 auto;
    transition: all 300ms $ease-in-out-sine;

    &:hover{
      transform: scale(1.4);
    }

    a{
      @include media("small-medium"){
        @include text-color(
          rgba(white, 1),
          rgba(white, 1)
        );
      }

      @include media("large"){
        @include text-color(
          rgba(white, $navigation-item-opacity),
          rgba(white, 1)
        );
      }

      padding: 1rem;
      text-decoration: none;
      line-height: 1;
      display: block;
      transition: all 300ms $ease-in-out-sine;
      font-weight: font-weights("light");

      span {
        @include media("small"){
          font-size: 2.5rem;
        }
        @include media("medium"){
          font-size: 2.5rem;
        }
        @include media("large"){
          font-size: 3rem;
        }

        font-weight: bold;
      }
    }
  }

  &__languages{
    @include media("small-medium"){
      padding: layout("spacing")/2 0;
    }
    @include media("large"){
      padding: layout("spacing") 0;
    }
  }
}
</style>
